import React from 'react';
import PropTypes from 'prop-types';
import { TimeWithTimeZone } from '@common/components';
import { StateBadge } from 'works/legacy/components/state-badge';
import { FontWeight } from '@common/tokens';

const COLOR_STYLE_MAP = {
  // From StaffingRequestApplication
  submitted: 'hypnotiq',
  submittal_packet_change_requested: 'hypnotiq',
  in_review: 'harvest-gold',
  accepted: 'grass-darkest',
  rejected: 'coral',
  withdrawn: 'sun-darker',
  // Virtual State from Offer
  offer_rejected: 'coral',
  offer_retracted: 'harvest-gold',
  offer_offered: 'grass',
  offer_change_requested: 'grass',
};

const LABEL_OVERWRITE = {
  offer_rejected: 'offer rejected',
  offer_retracted: 'offer retracted',
  offer_accepted: 'accepted',
  offer_offered: 'offer',
  offer_change_requested: 'offer change requested',
  submittal_packet_change_requested: 'change requested',
  submitted: 'submitted',
  in_review: 'in review',
  accepted: 'accepted',
};

export function getState(state, offerState) {
  // Virtual State logic...
  if (state === 'offer' && offerState) {
    return `${state}_${offerState}`;
  } else {
    return state;
  }
}

export function ApplicationStateBadge({
  state,
  timestamp,
  offerState,
  offerTimestamp,
  reason,
  rejectionDetails,
  lastComment,
  doNotRehire,
}) {
  timestamp = offerTimestamp ? offerTimestamp : timestamp;
  const currentState = getState(state, offerState);
  const doNotRehireFlag =
    doNotRehire &&
    LABEL_OVERWRITE[currentState] !== 'accepted' &&
    ' [Do Not Rehire]';

  return (
    <>
      <StateBadge
        state={
          <>
            <span>
              {LABEL_OVERWRITE[currentState] || currentState}
              {doNotRehireFlag}
            </span>
            {state === 'rejected' && (
              <>
                {reason && <span className="rejection-reason">{reason}</span>}
                {rejectionDetails && (
                  <span className="rejection-reason color-midnight-darkest">{`"${rejectionDetails}"`}</span>
                )}
              </>
            )}
          </>
        }
        lastComment={lastComment}
        caption={<TimeWithTimeZone date={timestamp} variant="long_format" />}
        color={COLOR_STYLE_MAP[currentState]}
      />
      <style jsx>{`
        .rejection-reason {
          display: block;
          font-weight: ${FontWeight.light};
        }
      `}</style>
    </>
  );
}

ApplicationStateBadge.propTypes = {
  state: PropTypes.string.isRequired,
  timestamp: PropTypes.string,
  offerState: PropTypes.string,
  offerTimestamp: PropTypes.string,
  reason: PropTypes.string,
  rejectionDetails: PropTypes.string,
  lastComment: PropTypes.node,
  doNotRehire: PropTypes.bool,
};
